// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e527fbb5","455":"2acbc107","977":"8a7b30d2"}[chunkId] + ".chunk.js";
};